var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql, useQuery } from '@apollo/client';
export var GET_TEAM_MEMBER_EMAIL_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getTeamMemberPortalData {\n    getTeamMemberPortalData {\n      teamMember {\n        email\n      }\n    }\n  }\n"], ["\n  query getTeamMemberPortalData {\n    getTeamMemberPortalData {\n      teamMember {\n        email\n      }\n    }\n  }\n"])));
export var useGetTeamMemberEmail = function (options) {
    if (options === void 0) { options = {}; }
    var result = useQuery(GET_TEAM_MEMBER_EMAIL_QUERY, __assign(__assign({}, options), { fetchPolicy: (options === null || options === void 0 ? void 0 : options.fetchPolicy) || 'network-only' }));
    return result;
};
var templateObject_1;
